export const TranslationsSR = {
    // languages
    languages: {
        en: 'English',
        ar: 'عربى',
        bg: 'Bulgaria',
        da: 'Dansk',
        de: 'Deutsch',
        es: 'Español',
        fi: 'Suomi',
        fr: 'Français',
        el: 'Ελληνικά',
        it: 'Italiano',
        id: 'Bahasa Indonesia',
        ja: '日本語',
        km: 'ភាសាខ្មែរ',
        nb: 'Bokmål',
        pt: 'Português',
        pa: 'ਪੰਜਾਬੀ',
        sv: 'Svenska',
        sr: 'Srpski',
        th: 'ภาษาไทย',
        vi: 'Tiếng Việt',
        zh: '中文',
    },
    codes: {
        en: 'EN',
        bg: 'BG',
        ar: 'AR',
        da: 'DA',
        de: 'DE',
        es: 'ES',
        fi: 'FI',
        fr: 'FR',
        el: 'EL',
        it: 'IT',
        id: 'ID',
        ja: 'JA',
        km: 'KM',
        nb: 'NB',
        pt: 'PT',
        pa: 'PA',
        sv: 'SV',
        sr: 'SR',
        th: 'TH',
        vi: 'VI',
        zh: 'ZH',
    },
    short_names: {
        en: 'ENG',
        ar: 'عربى',
        bg: 'BGR',
        da: 'DAN',
        de: 'DEU',
        es: 'ESP',
        fi: 'FIN',
        fr: 'FRA',
        el: 'ELL',
        it: 'ITA',
        id: 'IND',
        ja: '日本語',
        km: 'KHM',
        nb: 'NOB',
        pt: 'POR',
        pa: 'ਪੰਜਾਬੀ',
        sv: 'SVE',
        sr: 'SRP',
        th: 'THA',
        vi: 'VIE',
        zh: '中文',
    },
    // BASE
    phrases: {
        order_online: "Naruči online",
        cart: "Korpa",
        open_24: "24 Hours",
        closed: "Zatvoreno",
        free: "BESPLATNO",
        something_went_wrong: "nešto nije urađeno kako treba.",
        try_again: "Pokušajte ponovo",
    },
    constants: {
        calendar: {
            days: {
                monday: "Ponedeljak",
                tuesday: "Utorak",
                wednesday: "Sreda",
                thursday: "Četvrtak",
                friday: "Petak",
                saturday: "Subota",
                sunday: "Nedelja",
            },
        },
        services: {
            pickup: "Pokupiti",
            delivery: "Dostava",
            dine_in: "Dine-In",
            table_booking: "Rezervacija stolova",
        },
        payment: {
            method: {
                cash: "Keš",
                card: "Kartica",
                stripe: "Kreditna kartica",
                paypal: "PayPal",
                paygate_payweb: "PayGate PayWeb",
                poli_pay: "POLi Pay",
                ipay88: "iPay88",
                bambora_apac: "Bambora APAC",
                custom: "Ostalo",
            },
            backend_method: {
                cash: "Keš",
                card: "Kartica",
                stripe: "Card/Wallet",
                paypal: "PayPal",
                paygate_payweb: "PayGate PayWeb",
                poli_pay: "POLi Pay",
                ipay88: "iPay88",
                bambora_apac: "Bambora APAC",
                custom: "Ostalo",
            },
            status: {
                success: "Porudžbina uspešno primljena",
                pending: "Pričekajte",
                error: "Greška",
                refunded: "Refundiranje",
            },
        },
    },
    components: {
        field: {
            dropzone: {
                remove: "Ukloni",
                drop_here: "Ostavite vaše fajlove ovde ili kliknite za selektovanje",
                accepts: "Accepts {{fileTypes}} files",
                errors: {
                    max_files: "Maksimalan {{number}} dozvoljen",
                    max_size: "Maksimalna velišina fajla {{kilobytes}} KB",
                },
            },
        },
    },
    // UI
    store: {
        global: {
            buttons: {
                order: {
                    book_order: "Rezerviši sto / Poručite online",
                    order_online: "Poručite Onlajn",
                    book_table: "Rezerviši sto",
                    order: "Porudžbina",
                    book: "Rezervacija",
                    cart: "Korpa",
                    restart: "Restart",
                    closed: "Radnja se zatvara",
                    not_accepting: "Ne prihvatamo porudžbine",
                },
            },
        },
        modals: {
            auth: {
                login: "Logovanje",
                register: "Registracija",
                register_commence: "Nastavi",
                register_complete: "Kreiraj nalog",
                register_confirmation_sent: "Kod za potvrdu je poslat na Vaš e-mail.",
                register_confirmation_resent: "Kod je ponovo poslat.",
                register_restart: "Restart",
                register_resend_code: "Pošaji kod ponovo",
                login_placeholder: "E-mail",
                password_placeholder: "Šifra",
                confirmation_code_placeholder: "E-Mail kod za potvrdu",
                accept_terms: "Prihvati uslove",
                accept_terms_view: "Pogledajte",
                login_facebook: "Uloguj se preko Facebook",
                login_google: "Uloguj se preko Google",
                benefits: "Uloguj se ili kreiraj nalog da bi sašuvao sve tvoje narudžbine",
                logged_in: "Uspešno logovanje",
                logged_out: "Uspešno ste se izlogovali",
                error_generic: "Nešto nije u redu, molim Vas pokušate ponovo ili nas kontaktirajte",
                error_accept_terms: "Molim Vas prihvatite uslove korišćenja",
                error_password_length: "Potrebno je minimum 6 karaktera za lozinku",
                error_social: "Nešto nije u redu, molim Vas pokušate ponovo ili nas kontaktirajte",
                error_confirmation_code: "Nevažeći kod za potvrdu",
                error_invalid_code: "Nevažeći kod za potvrdu",
                error_exists: "Korisnik već postoji",
                error_invalid_email_pass: "Nevažeći e-mail, adresa ili lozinka",
            },
            booking: {
                form: {
                    name: "Puno ime",
                    email: "E-Mail adresa",
                    phone: "Broj telefona",
                    number_of_people: "Broj ljudi",
                    number_of_people_max: "Broj ljudi ({{max_people}} Max)",
                    number_of_people_min: "Broj ljudi ({{min_people}} Min)",
                    number_of_people_max_min: "Broj ljudi (Between {{min_people}} to {{max_people}})",
                    notes: "Napomene / posebni zahtevi",
                    submit: "Potvrdi rezervaciju",
                    email_optional: "(опционо)",
                    date: "Датум",
                    duration: "Трајање",
                    seating: "Слободни термини",
                    number_of_guests: "Број гостију",
                    notes_placeholder: "Алергије, повод, жеља за местом",
                    reserving: "Резервисање...",
                    reserve_table: "Резервиши сто",
                    please_choose_a_date_and_time: "Изаберите датум и време.",
                    invalid_people: "Број особа мора бити између {{min}} и {{max}}.",
                    party_size_max_fallback: "дозвољени максимум",
                    loading_available_times: "Учитавање слободних термина…",
                    select_a_date_to_see_available_times: "Изаберите датум да бисте видели слободне термине.",
                    no_times_available_for_this_date: "Нема слободних термина за овај датум. Изаберите други дан.",
                    shift: "Смена",
                    service_times: "Радно време",
                    new_shift: "Нова смена",
                    time: "термин",
                    times: "термини",
                    unavailable: "Недоступно",
                    available: "Доступно",
                    required_name: "Унесите своје име.",
                    required_phone: "Унесите број телефона.",
                    required_email: "Унесите адресу е-поште.",
                    invalid_email: "Унесите исправну адресу е-поште.",
                    required_terms: "Прихватите услове пре резервације.",
                    missing_custom_fields: "Одговорите на сва обавезна питања.",
                    reservation_is_unavailable: "Резервација није доступна.",
                    please_contact_the_restaurant_directly: "Контактирајте ресторан директно.",
                    almost_done: "Скоро готово",
                    your_details: "Ваши подаци",
                    tell_us_who_s_coming: "Реците нам ко долази да бисмо потврдили вашу резервацију.",
                    book_your_table: "Резервишите сто",
                    choose_a_time_that_works_for_you: "Изаберите термин који вам одговара.",
                    send_your_reservation_request_and_the_restaurant_will_take_care_of_the_rest: "Пошаљите захтев за резервацију, а ресторан ће се побринути за остало.",
                    select_date: "Изаберите датум",
                    standard: "Стандардно",
                    minutes: "минута",
                    next: "Даље →",
                    back: "← Назад",
                    accept_terms: "Прихватам услове коришћења.",
                    info_1: "Kada primite ili odbijete rezervaciju, dobićete obaveštenje putem e-pošte",
                },
                errors: {
                    not_found: "Rezervacija ne postoji. Možda je obrisana",
                    generic: "Nešto nije u redu, molim Vas pokušate ponovo ili nas kontaktirajte",
                    something_went_wrong: "Nešto nije u redu",
                    accept_terms: "Molim Vas, prihvatite uslove korišćenja",
                    required_phone: "Unesite Vaš broj telefona",
                    required_email: "Unesite Vaš e-mail",
                    required_name: "Unesite Vaše ime",
                    invalid_email: "Unesite ispravnu e-mail adresu",
                    invalid_people: "Neispravan broj ljudi",
                    booking_capacity_threshold: "За овај термин смо попуњени. Покушајте други термин.",
                    slot_unavailable: "За овај број особа смо попуњени. Покушајте други термин.",
                    booking_date_paused: "Резервације су паузиране за овај датум. Изаберите други дан.",
                    invalid_table_assignment: "Ови столови не могу да приме ваше друштво. Изаберите друго време.",
                    exceeded_order_limit: "Превише захтева за резервацију. Покушајте касније.",
                    validation_failed_recaptcha_v3: "Откривен је неуобичајен саобраћај. Користите ли VPN? Завршите проверу изнад и покушајте поново.",
                    validation_failed_recaptcha_v2: "Резервација није могла да почне. Покушајте поново или користите други начин. Ако користите VPN, прво га искључите.",
                    booking_already_exists: "Ова резервација је већ послата. Проверите е-пошту или отворите линк резервације.",
                    invalid_party_size: "Изаберите исправан број особа.",
                    invalid_request: "Неисправан захтев. Освежите страницу и покушајте поново.",
                    table_booking_unavailable: "Резервација стола није доступна.",
                },
            },
            cart: {
                title: "Korpa",
                proceed_to_checkout: "Idi na plaćanje",
                edit_dish: "Editovanje",
                remove_dish: "Ukloni",
                no_items_1: "Nema proizvoda u korpi",
                no_items_2: "Dodajte prvo nešto u korpu da biste nastavili",
                free_delivery_notice: "Besplatna dostava za narudžbine preko {{value, currency}}",
                errors: {
                    min_order_promo: "Minimalna vrednost korpe je {{value, currency}} potrebna pre primene ove promocije",
                    min_order_delivery: "Minimalna vrednost korpe je {{value, currency}} za dostavu",
                },
                promo: {
                    heading: "Promo kod",
                    placeholder: "Upišite Vaš promo kod",
                    add: "Dodajte kod",
                    title: "Promo {{name}} dodat u korpu",
                    fixed_discount: "{{value, currency}} Off",
                    percent_discount: "{{value}}% Off",
                    added_to_cart: "Promocija je dodata u korpu",
                    errors: {
                        not_found: "Promocija nije pronađena",
                        disabled: "Promocija je onemogućena",
                        not_available: "Promocija trenutno nije dostupna",
                        logged_in_only: "Morate biti ulogovani da bi iskoristili promociju",
                        already_used: "Već ste koristili ovu promociju",
                        invalid: "Ova promocija više ne važi",
                        invalid_service: "Ova promocija ne važi za izabranu uslugu",
                        generic: "Oops... nešto nije u redu sa logovanjem",
                        dishes_required_multi: "Ova promocija će se primenjivati samo kada se određena jela dodaju u korpu",
                        dishes_required_single: "Ova promocija će se primenjvati samo za '{{dish}}'",
                    },
                },
                tip: {
                    title: "Savet za porudžbinu",
                    placeholder: "Dodajte savet za porudžbinu",
                },
            },
            checkout: {
                title: "Završi porudžbinu",
                subtitle: "Potvrdite Vaše informacije za porudžbinu",
                details: {
                    service: "Servis",
                    due: "Due",
                    due_now_asap: "Odmah",
                    address: "Adresa dostave",
                    total: "Ukupno",
                    table: "Sto",
                    store_location: "Adresa lokala",
                },
                customer: {
                    title: "Kupac",
                    subtitle: "Ulogujte se da biste sačuvali Vaše podatke",
                    button: "Login",
                    name: "Puno ime",
                    email: "E-Mail adresa",
                    phone: "Broj telefona",
                    phone_important: "Broj telefona (obavezno)",
                    notes: "Napomena",
                    delivery_notes: "Informacije o dostavi",
                    optional: "Opciono"
                },
                payment: {
                    title: "Način plaćanja",
                },
                accept_terms: "Prihvati uslove korišćenja",
                accept_terms_view: "View",
                processing_order: "Porudžbina u procesu",
                warning: {
                    different_payment_currency: "Cene u prodavnicama su u {{store_currency}} ,ali metoda plaćanja je u {{payment_currency}}",
                    closing_soon: "Uskoro zatvaramo, poručite u narednih {{value}} minutes",
                    closed: "Izvinite, ova usluga je zatvorena i nalozi se ne prihvataju",
                    expired: "Više ne možemo ispuniti vašu narudžbinu u odabrano vreme. Molimo, odaberite kasniji datum ili vreme",
                },
                errors: {
                    stripe_generic: "Greška kreditne kartice, pokušajte ponovo ili odaberite neki drugi metod",
                    stripe_loading_fail: "Greška pri učitavanju obrasca, molimo, pokušajte ponovo",
                    something_went_wrong: "Nešto nije u redu",
                    paypal_generic: "Nešto nije u redu sa PayPal-om, pokušajte ponovo ili odaberite neki drugi metod",
                    payment_fail: "Plaćanje neuspešno, pokušajte ponovo ili odaberite neki drugi metod",
                    payment_cancelled: "Plaćanje otakazano, pokušajte ponovo ili odaberite neki drugi metod",
                    payment_error: "Greška prilikom obrade online plaćanja, pokušajte ponovo ili odaberite neki drugi metod",
                    card_declined: "Vaša kartica je odbijena i plaćanje nije moguće obraditi",
                    promo_max_uses_exceeded: "Ovaj promo kod je dostigao ograničenje korišćenja i više nije dostupan.",
                    store_closed: "Prodavnica je zatvorena i više ne prihvata narudžbine",
                    accept_terms: "Prihvatite uslove i odredbe",
                    required_payment: "Izaberite način plaćanja",
                    required_phone: "Unesite Vaš broj telefona",
                    required_email: "Unesite Vaš e-mail",
                    required_name: "Unesite Vaše ime",
                    invalid_email: "Unesite ispravnu e-mail adresu",
                    invalid_phone: "Unesite ispravan broj telefona",
                    closed: "Radnja je zatvorena i ne prihvata nove proudžbine",
                    promo_login_required: "Morate biti ulogovani da biste iskoristili ovu promociju",
                    promo_used: "Već ste iskoristili ovu promociju",
                },
                button: {
                    continue: "Produži ka plaćanju",
                    place_order: "Naručite",
                },
            },
            customer: {
                age_v: {
                    title: "Verifikacija starosti",
                    required_for_items: "Potrebno je naručiti određene stavke",
                    min_age: "Minimalna starost: {{age}} godina",
                    est_time: "Procenjeno vrijeme provere: {{time}} sati",
                    upload_description: "Postavite svoj ID ispod za verifikaciju. Bićete obavešteni putem e-maila kada budete potvrđeni. Otpremite do 2 slike maksimalne veličine od po 2 MB",
                    pending_description_1: "Hvala vam što ste poslali dokumente. Bićete obavešteni putem e-maila kada budete odobreni",
                    pending_description_2: "Osvežite stranicu da biste ažurirali status verifikacije. Procenjeno vrijeme provere je {{time}} sati",
                    approved_description: "Vaš nalog je verifikovan i možete naručiti iz ograničenih menija",
                    rejected_description: "Vaš ID je odbijen. Ako želite da pokušate ponovo, ponovo učitajte svoj ID",
                    upload: "Otpremiti",
                    reupload: "Ponovo učitajte dokumente",
                    go_back: "Vrati se nazad",
                    view_document: "Pogledate dokument {{number}}",
                    status: {
                        unverified: "Nije potvrđeno",
                        pending: "Čeka se odobrenje",
                        approved: "Uspešno verifikovano",
                        rejected: "Odbijen",
                    },
                },
                headings: {
                    sessions: "Sesija",
                    orders: "Porudžbina",
                    spend: "Potrošnja",
                    order_history: "Istorija porudžbina",
                    loyalty_points: "Bodovi lojalnosti",
                },
            },
            dish: {
                add: "Dodaj u korpu",
                edit: "Izmeni proizvod",
                notes: "Napomena",
                ingredients: {
                    title: "Dodaci",
                    uncheck_remove: "Kliknite ponovo da uklonite",
                },
                ingredients_title: "Sastojci",
                combo: {
                    choose_dish: "Izaberi jelo",
                },
                option_sets: {
                    conditions: {
                        select_one: "Izaberi jedan (Obavezno)",
                        select_one_optional: "Izaberi jedan (Opciono)",
                        select_between: "Izaberi između {{min}} - {{max}} (Obavezno)",
                        select_at_least: "Izaberi najmanje {{qty}} (Obavezno)",
                        select_up_to: "Izaberi do {{qty}} (Opciono)",
                        select_multiple: "Izaberi više (Opciono)",
                        free_amount: "Prvo {{qty}} Besplatno / {{selected}} Izabrano",
                    },
                },
                error: "Ispravite sve opcije označene crvenom bojom",
                added_to_cart: "Stavka je dodata u korpu",
            },
            map: {
                zone_fee: "Cena dostave",
                view_in_google: "Prikaži u Google mapama",
            },
            portal_go_back: {
                title: "Vratite se u restoran za pretragu?",
                description: "Sve što se izabrali biće izgubljeno",
                cancel: "Otkažite",
                proceed: "Vratite se nazad",
            },
            order: {
                config: {
                    services: {
                        title: "Izaberite uslugu",
                        table_booking: "Rezervišite sto",
                    },
                    address_custom: {
                        input_placeholder: "Upišite vašu adresu",
                    },
                    address: {
                        input_placeholder: "Pronađite Vašu adresu",
                        extras_placeholder: "Unit number, building name, delivery instructions, etc...",
                        search_placeholder: "Potražite Vašu adresu",
                        not_found: "Pokušajte ponovo",
                        not_delivering: "Ne vršimo trenutno dostavu na toj adresi.",
                        not_in_range: "Ta adresa ne odgovara našim uslovima dostave.",
                        not_in_zone: "Ta adresa nije u zoni gde vršimo dostavu.",
                        location_permission: "Dopustiti ovoj web stranici pristup vašoj trenutačnoj lokaciji?",
                        location_permission_warning: "Ne možete pristupiti vašoj trenutačnoj lokaciji. Omogućite uslugu lokacije na svom uređaju i web-pregledniku. Evo nekih referenci:",
                        pick_location: "Odaberite svoju lokaciju",
                        pick_location_help_text: "Povucite oznaku za odabir lokacije na karti.",
                        use_current_location: "Koristite trenutnu lokaciju",
                        locate_on_map: "Pronađite na karti",
                    },
                    datetime: {
                        title: "Za kada biste želeli da poručite?",
                        due_now: "Sada",
                        due_later: "Kasnije",
                        service_not_available: "Žao nam je, treutno ne prihavtamo porudžbine za {{service}}",
                        currently_closed: "{{service}} trenutno zatvoreno, ali možete poručiti za kasnije",
                        due_unavailable: "Nije dostupnp",
                        due_closed: "Zatvoreno",
                        select_date: "Izaberite datum",
                        select_time: "Izaberite vreme",
                        select_order_date: "Izaberite datum",
                        select_order_time: "Izaberite vreme",
                        select_booking_date: "Izaberite datum rezervacije",
                        select_booking_time: "Izabetite vreme rezervacije",
                        no_times_available: "Nema vremena za izbor",
                        date_today: "(Danas)",
                        date_closed: "(Zatvoreno)",
                        date_bookings_paused: "(Резервације паузиране)",
                        time_slot_closed: "Zatvoreno",
                    },
                    number_of_people: {
                        placeholder: "Broj ljudi",
                    },
                    table: {
                        select: "Izaberite sto",
                        select_popup_title: "Izaberite Vaš sto",
                        password: "Šifra stola",
                        password_warning: "Unesite šifru stola da biste nastavili",
                    },
                    warning: {
                        closed: "Trenutno smo zatvoreni",
                        not_available: "Trenutno ne prihvatamo porudžbine",
                    },
                    start_button: "Započnite porudžbinu",
                },
                history: {
                    invalid: "Ne ispunjavaju uslove za ponovno naručivanje jer su neke od naručenih stavki izmenjene ili više nisu dostpune",
                },
                reorder: {
                    title: "Brzo ponovo poručite",
                    description: "Lako naručite stavke iz prethodnih narudžbina",
                },
            },
            receipt: {
                errors: {
                    not_found: "Porudžbina ne postoji, verovano je obrisana.",
                    booking_not_found: "Резервација не постоји. Могуће је да је обрисана",
                    generic: "Nešto nije u redu, refrešujte stranicu ili nas kontaktirajte",
                },
                connection: {
                    connected: "Real-time updates",
                    connecting: "Real-time updates connecting",
                    disconnected: "Real-time updates disconnected",
                },
            },
            warnings: {
                logout: {
                    pretitle: "Upozorenje",
                    title: "Odjaviti se",
                    body: "Odjava će ukloniti sve stavke koje su dodate u Vašu korpu",
                    cancel: "Otkazati",
                    proceed: "Nastaviti",
                },
                order_restart: {
                    warning: "Upozorenje",
                    title: "Promeni detalje narudžbine",
                    body: "Promena detalja narudžbine će ukloniti stavke u vašoj korpi jer određena jela mogu postati nedotupna",
                    cancel: "Otkazati",
                    proceed: "Nastaviti",
                },
                order_expired: {
                    subtitle: "Važno",
                    title: "Nalog je odmah promenjen",
                    description: "Vreme koje ste izabrali za vašu narudžbinu nije daleko. Kao takva, vaša narudžbina je izmenjena tako da bude odmah / ASAP",
                    button: "Ok",
                },
                order_expiring: {
                    subtitle: "Važno",
                    title: "Rok porudžbine uskoro ističe",
                    description: "Vaša narudžbina mora biti postavljena ranije {{time, timeFromTimestamp}} u suprtonom, neće važiti",
                    button: "Ok",
                },
                location_permission: {
                    cancel: "Otkazati",
                    proceed: "Nastaviti",
                },
            },
            maps: {
                cancel: "Otkazati",
                use_location: "Koristite lokaciju",
            },
        },
        sections: {
            nav_top: {
                guest: "Gost",
                login_signup: "Logovanje / Registracija",
                logout: "Izlogujte se",
            },
            menus: {
                info: {
                    no_menus: "Trenutno nema dostupnih menija",
                    restrictions: "Ograničenja u meniju",
                    not_available: "Meni trenutno nije dostpan",
                    unavailable: {
                        times: "Meni je nedostpuan, zahtevi narudžbine se ne podudaraju",
                        services: "Meni je nedostpuan, zahtevi narudžbine se ne podudaraju",
                        hours: "Meni je nedostpuan, Vaši sati narudžbine nisu unutar ovih menija na raspolaganju",
                        pre_order: "Meni je nedostpuan, Vaša narudžbina ne odgovara zahtevima za pred-narudžbinu",
                        age: "Meni je nedostpuan, iz ovog menija morate biti prijavljeni sa nalogom za verifikaciju uzrasta",
                    },
                    services: {
                        title: "Zahtevi narudžbine",
                        pickup: "Za preuzimanje",
                        delivery: "Dostave",
                        dine_in: "Dine-Ins",
                    },
                    times: {
                        now: "Nema pred-narudžbina",
                        later: "Samo pred-narudžbine",
                    },
                    hours: {
                        title: "Dostupni sati",
                    },
                    preorder: {
                        title: "Zahtevi za pred-porudžbinu",
                        days_in_advance: "Naruči {{days}} dana unapred",
                        cutoff_time: "Vreme poslednjeg prekida u  {{time, timeFromTime}}",
                    },
                    age_restricted: {
                        title: "Starosna granica",
                        approved: "Vaš nalog je verifikovan i možete ga naručiti iz ovog menija",
                        rejected: "Potrebna je verifikacija godina. Otvorite nalog i postavite svoj ID",
                    },
                },
            },
            info: {
                location: {
                    title: "Lokacija",
                    view_map: "Pogledajte mapu",
                    phone: "Broj telefona",
                },
                hours: {
                    title: "Vreme otvaranja",
                    title_special: "Specijalno otvaranje",
                },
                services: {
                    title: "Servisi",
                    notes: "Napomene",
                    delivery: {
                        ranges: "Opseg dostave",
                        zones: "Zona dostave",
                        view_zones: "Pogledaj zone na mapi",
                        fee: "Cena dostave",
                        fee_short: 'Cena',
                        min_order: "Minimalna porudžbina",
                        min_order_short: 'Min. por.',
                        no_min_order: "Nema minimalne porudžbine",
                        free_amount: "Besplatna dostava",
                    },
                },
            },
            contact: {
                title: "Kontaktirajte nas",
                name: "Ime",
                email: "E-mail",
                phone: "Broja telefona",
                message: "Vaša poruka",
                send: "Pošaljite poruku",
                success: "Poruka uspešno poslata",
                error: "Greška",
            },
            footer: {
                powered_by: "Kreirano od",
                terms_and_conditions: "Uslovi korišćenja",
            },
        },
    },
    // MODELS
    booking: {
        receipt: {
            title: 'Potvrda o rezervaciji',
            details: {
                datetime: 'Rezervacija za',
                number_of_people: 'No. Of People',
                placed: 'Postaviti',
                updated: 'Poslednje ažuriranje',
                notes: 'Beleške',
                name: 'Ime',
                email: 'E-Mail',
                phone: 'Telefon',
                store_address: 'Adresa radnje',
            },
            status_update: {
                title: 'Rezervacija {{number}} Ažurirana',
                body: 'Status rezervacije je ažuriran na {{status}}',
            },
            email_status_update_customer: {
                subject: 'Резервација #{{number}} – {{subjectLabel}}',
                body: 'Ваша резервација #{{number}} у {{store}} је сада {{status}}.',
            },
            errors: {},
        },
    },
    email_delayed_order: {
        subject: 'Поруџбина #{{number}} – {{subjectLabel}}',
        header: 'Ажурирано време спремности',
        title: 'Ажурирано време спремности',
        order_number: 'Редни број: {{number}}',
        description: 'Ваша поруџбина ће сада бити спремна у {{time}}.',
        order_time_updated_to: 'Време ваше поруџбине је ажурирано.',
        powered_by: 'Покреће га {{name}}',
        button_text: 'Трацк Ордер',
        subject_label: 'Ажурирано време спремности',
        subject_label_delivery: 'Ажурирано време испоруке',
        body_ready: 'Ваша поруџбина ће сада бити спремна у {{time}}.',
        body_delivery: 'Ваша поруџбина ће сада бити испоручена у {{time}}.',
    },
    order: {
        receipt: {
            est_ready_time: 'Est. Ready Time',
            est_delivery_time: 'Est. Delivery Time',
            tab_details: 'Detalji',
            tab_dishes: 'Jela',
            details: {
                placed: 'Postavljeni',
                due: 'Due',
                due_asap: 'ASAP',
                last_updated: 'Poslednje ažuriranje',
                total: 'Ukupno',
                type: 'Tip',
                table: 'Sto',
                payment_method: 'Metod plaćanja',
                payment_status: 'Status plaćanja',
                notes: 'Beleške',
                name: 'Ime',
                email: 'E-Mail',
                phone: 'Telefon',
                delivery_address: 'Adresa za isporuku',
                delivery_tracking: 'Praćenje isporuke',
                delivery_tracking_link: 'Veza za praćenje u realnom vremenu',
                store_address: 'Adresa prodavnice',
            },
            dishes: {
                headings: {
                    quantity: 'Količina',
                    item: 'Proizvod',
                    price: 'Cena',
                },
                notes: 'Napomena',
                remove_ingredients: 'Ukloni sastojke',
            },
            status_update: {
                title: 'Naručite {{number}} Ažurirano',
                body: 'Status vaše porudžbine je ažuriran na{{status}}',
            },
            wait_time_update: {
                title: 'Naručite {{number}} Ažurirano',
                body: 'Vreme ažuriranja vaše narudžbe je ažurirano',
            },
            delivery_update: {
                title: 'Naručite {{number}} Ažurirano',
                body: 'Vaša narudžba je rezervisana za isporuku. Pogledajte vezu za praćenje u realnom vremenu',
            },
            payment_status_update: {
                title: 'Order {{number}} Updated',
                body: 'Your order payment status has been updated.',
            },
            email_new_order_restaurant: {
                subject: "New Order ({{number}}) - {{name}}",
                powered_by: "Powered By {{name}}",
                overview: "New Order Notification",
                title: "New Order Placed At {{name}}",
                subtitle: "Order Number {{number}}",
                description: "View details and updates through your admin dashboard",
                button_text: "Track Order",
                track_delivery_button_text: "Pratite isporuku",
            },
            email_new_order_customer: {
                subject: "Order Receipt ({{number}})",
                powered_by: "Powered By {{name}}",
                overview: "New Order Notification",
                title: "New Order Placed At {{name}}",
                subtitle: "Order Number {{number}}",
                description: "View details and updates through your real-time online receipt",
                button_text: "Track Order",
                track_delivery_button_text: "Pratite isporuku",
            },
        },
        totals: {
            tax: "{{name}} ({{percent}}%)",
            tax_in_prices: "{{name}} ({{percent}}%) inc. in price",
            fee: "{{name}} ({{value, currency}} + {{percent}}%)",
            fee_percent: "{{name}} ({{percent}}%)",
            fee_fixed: "{{name}}",
            delivery_fee: "Delivery Fee",
            promo: "Discount: {{name}} ({{value, currency}} + {{percent}}% Off)",
            promo_percent: "Discount: {{name}} ({{percent}}%)",
            promo_fixed: "Discount: {{name}}",
            cart: "Korpa",
            tip: "Vrsta porudžbine",
            total: "Ukupno",
        },
        status: {
            unconfirmed: "Nepotvrđeno",
            awaiting_payment: "Чека се плаћање",
            confirmed: "Potvrđeno",
            ready: "Spremno",
            on_route: "Na čekanju",
            complete: "Završeno",
            cancelled: "Obustavljeno",
            seated: "Смештени",
        },
    },
    restaurant: {
        menus: {
            option_set: {
                option: {
                    unavailable: "Nije dostupno",
                },
            },
            dish: {
                no_stock: "Nema na stanju",
                not_available: "Nije dostupno",
            },
        },
    },
};
//# sourceMappingURL=sr.js.map